import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RolloutProductUpdateDate({
  date
}) {
  if (!date) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'app.noDate'
    });
  }
  return /*#__PURE__*/_jsx(FormattedDateTime, {
    type: "userTz",
    value: date,
    format: "LL"
  });
}